(function () {
  'use strict';

  angular.module('app').component('transportationsPage', transportationListCtrl());

  function transportationListCtrl() {
    return {
      bindings: {},
      controller: TransportationListCtrl,
      controllerAs: 'vm',
      templateUrl: './app/ajs/transportation/transportations-page.component.html',
    };
  }

  TransportationListCtrl.$inject = [
    '$location',
    'AbilityService',
    'SessionService',
    'TransportationService',
    'LanguageService',
  ];

  function TransportationListCtrl(
    $location,
    AbilityService,
    SessionService,
    TransportationService,
    LanguageService
  ) {
    var vm = this;

    vm.permissions = {
      canCreate: AbilityService.can('create_transportation_accountadmin'),
    };

    vm.userLanguageCode = SessionService.getUserLanguage().code;

    // Methods
    vm.createItem = createItem;
    vm.onShowItem = onShowItem;

    // Initializers
    getDefaultLanguage();

    function getDefaultLanguage() {
      LanguageService.getLanguages({ get: 'is_default', skip_check_role: true }).then(function (
        data
      ) {
        vm.defaultLanguage = data.items.lang;

        getTransportations();
      });
    }

    function getTransportations() {
      let filterCriteria = TransportationService.getFilterCriteria();
      // filterCriteria.lang = vm.defaultLanguage;

      vm.loadingItems = true;
      TransportationService.getTransportations(filterCriteria).then(function (data) {
        vm.items = data.items;
        vm.meta = data.meta;

        vm.totalItems = vm.meta.totalItems;

        vm.loadingItems = false;
      });
    }

    function createItem() {
      $location.path('/transportation/new');
    }

    function onShowItem(item, mode) {
      $location.path(`/transportation/${item.id}`).search({ mode: mode });
    }
  }
})();
